import styled from 'styled-components';

const LabelLayout = styled.div `
  .label-name {
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: var(--gray-color-6);

    .label-info-icon {
      margin: 0 3px;
      transform: translateY(1px);
    }
  }
`;

export { LabelLayout };
